import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ErrorHandler } from './error-handler.service';

// Import the required Google Maps typings
import { Loader } from '@googlemaps/js-api-loader';
import { GoogleMapsService } from './googleMap.service';
declare var google: any;

@Injectable({
  providedIn: 'root',
})
export class LocationHotelBusinessService {
  public hotelBusinessLocations$: Subject<any> = new Subject();
  public hotelBusinessItem$: Subject<any> = new Subject();

  private googleMapsLoaded: boolean = false;
  private autocompleteService: google.maps.places.AutocompleteService | null = null;

  constructor(private _errorService: ErrorHandler, private _GoogleMapsService: GoogleMapsService) {

    this._GoogleMapsService
      .load()
      .then(() => {
        this.googleMapsLoaded = true;
        this.autocompleteService = new google.maps.places.AutocompleteService();
      })
      .catch((error) => {
        console.error('Error loading Google Maps API:', error);
        this._errorService.handleError(error);
      });
  }

  getLocationData(value: string, country: string) {
    if (!this.googleMapsLoaded || !this.autocompleteService) {
      console.error('Google Maps API not loaded yet');
      return;
    }

    this.autocompleteService.getPlacePredictions(
      {
        input: value,
        types: ['establishment'],
        componentRestrictions: { country },
      },
      this.displaySuggestions.bind(this)
    );
  }

  displaySuggestions(predictions: google.maps.places.AutocompletePrediction[] | null, status: google.maps.places.PlacesServiceStatus) {
    if (status === google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
      this.hotelBusinessLocations$.next(throwError(() => status));
      this._errorService.handleError(status);
      return;
    }
    if (status !== google.maps.places.PlacesServiceStatus.OK) {
      this.hotelBusinessLocations$.next(throwError(() => status));
      this._errorService.handleError(status);
      return;
    }
    this.hotelBusinessLocations$.next(predictions);
  }

  setLocationSelection(data: Object) {
    this.hotelBusinessItem$.next(data);
  }
}
